import { createSelector } from '@ngrx/store';
import { getOneClickState } from '../reducers';

export const getOneClickBusinesslinesState = createSelector(
  getOneClickState,
  state => state.businessLinesState,
);

export const getOneClickBusinessLines = createSelector(
  getOneClickBusinesslinesState,
  state => state.businessLinesAvailable,
);

export const getOneClickBusinessLinesSelected = createSelector(
  getOneClickBusinesslinesState,
  state => state.selected,
);
